<script>
import Client from "@/components/_Shared/OrdersAndSubscriptions/Client";
import Address from "@/components/_Shared/OrdersAndSubscriptions/Address";
import ToBe from "@/components/_Shared/OrdersAndSubscriptions/ToBe";
import Informations from "@/components/_Shared/OrdersAndSubscriptions/Informations";
import Confirm from "@/components/_Shared/OrdersAndSubscriptions/Confirm";

import PerSchedule from "./PerSchedule";
import PerProfessional from "./PerProfessional";

import { mapState, mapGetters, mapActions } from "vuex";

export default {
  computed: {
    // ...mapState("newPurchase", [
    //   "address_id",
    //   "to_be",
    //   "professional_id",
    //   "day_of_week",
    //   "frequency",
    //   "start_at",
    //   "end_at",
    //   "information"
    // ])
  },

  components: {
    Client,
    Address,
    ToBe,
    PerSchedule,
    PerProfessional,
    Informations,
    Confirm
  },

  methods: {
    scrollTo(id) {
      var t = this;

      setTimeout(function() {
        t.$scrollTo(id, 300, {
          offset: -30
        });
      }, 25);
    }
  }
};
</script>

<template>
  <div class="box">
    <transition name="fade" mode="out-in">
      <Client @scrollTo="scrollTo($event)"/>
    </transition>

    <transition name="fade" mode="out-in">
      <Address @scrollTo="scrollTo($event)"/>
    </transition>

    <transition name="fade" mode="out-in">
      <to-be
        @scrollTo="scrollTo($event)"
      />
    </transition>

    <transition name="fade" mode="out-in">
      <PerSchedule
        @scrollTo="scrollTo($event)"
      />
    </transition>

    <transition name="fade" mode="out-in">
      <PerProfessional
        @scrollTo="scrollTo($event)"
      />
    </transition>

    <transition name="fade" mode="out-in">
      <Informations
        @scrollTo="scrollTo($event)"
      />
    </transition>

    <transition name="fade" mode="out-in">
      <Confirm
        @scrollTo="scrollTo($event)"
      />
    </transition>
  </div>
</template>

<style scoped>
.section.passed-on {
  opacity: 0.35;
}

.section.passed-on:hover,
.section.passed-on:active {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Subscription/NewSubscription/Index.vue